class Bolts {
  constructor() {
      this.arrayBolts = 
        [
          {
            name: "SA-193 Gr.B7 100 < t <= 180",
            material: "SA-193 Gr.B7",
            size_class: "100 < t < 180",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 130, "100": 130, "125": 130, "150": 130, "175": 130, "200": 130, "225": 130, "275": 130, "300": 130, "325": 130, "350": 130, "375": 130, "400": 130, "425": 125, "450": 115, "475": 93.7, "500": 68.4, "525": 43.7, "550": 18.9 }
          },
          {
            name: "SA-193 Gr.B7 64 < t <= 100",
            material: "SA-193 Gr.B7",
            size_class: "64 < t < 100",
            unit: "Stress (MPa)",
            stresses: { "40": 159, "65": 159, "100": 159, "125": 159, "150": 159, "175": 159, "200": 159, "225": 159, "275": 159, "300": 159, "325": 159, "350": 159, "375": 158, "400": 153, "425": 139, "450": 117, "475": 93, "500": 68.6, "525": 43.7, "550": 18.9 }
          },
          {
            name: "SA-193 Gr.B7 t <= 64",
            material: "SA-193 Gr.B7",
            size_class: "t <= 64",
            unit: "Stress (MPa)",
            stresses: { "40": 172, "65": 172, "100": 172, "125": 172, "150": 172, "175": 172, "200": 172, "225": 172, "275": 172, "300": 172, "325": 172, "350": 172, "375": 172, "400": 172, "425": 172, "450": 164, "475": 148, "500": 68.8, "525": 43.7, "550": 18.9 }
          },
          {
            name: "SA-193 Gr.B16 100 < t <= 200",
            material: "SA-193 Gr.B16",
            size_class: "100 < t < 200",
            unit: "Stress (MPa)",
            stresses: { "40": 138, "65": 138, "100": 138, "125": 138, "150": 138, "175": 138, "200": 138, "225": 138, "275": 138, "300": 138, "325": 138, "350": 138, "375": 138, "400": 138, "425": 138, "450": 132, "475": 119, "500": 88.8, "525": 43.7, "550": 18.9 }
          },
          {
            name: "SA-193 Gr.B16 64 < t <= 100",
            material: "SA-193 Gr.B16",
            size_class: "64 < t < 100",
            unit: "Stress (MPa)",
            stresses: { "40": 152, "65": 152, "100": 152, "125": 152, "150": 152, "175": 152, "200": 152, "225": 152, "275": 152, "300": 152, "325": 152, "350": 152, "375": 152, "400": 152, "425": 152, "450": 147, "475": 133, "500": 114, "525": 90.4, "550": 61.1, "575": 34.5, "600": 13.7 }
          },
          {
            name: "SA-193 Gr.B16 t <= 64",
            material: "SA-193 Gr.B16",
            size_class: "t < 64",
            unit: "Stress (MPa)",
            stresses: { "40": 172, "65": 172, "100": 172, "125": 172, "150": 172, "175": 172, "200": 172, "225": 172, "275": 172, "300": 172, "325": 172, "350": 172, "375": 172, "400": 172, "425": 172, "450": 164, "475": 148, "500": 128, "525": 98.1, "550": 77.6, "575": 67.6, "600": 34.3, "625": 13.8 }
          },
          {
            name: "SA-193 Gr.B8Mclass 1",
            material: "SA-193 Gr.B8M",
            size_class: "class 1",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 127, "100": 121, "125": 114, "150": 107, "175": 103, "200": 99.2, "225": 95.9, "275": 92.8, "300": 90.2, "325": 88.1, "350": 86.1, "375": 84.4, "400": 83.2, "425": 82, "450": 80.7, "475": 80.1, "500": 78.8, "525": 78.8, "550": 78.8, "575": 78.8, "600": 78.8, "625": 65.5, "650": 50.4, "675": 38.6, "700": 29.6, "725": 23, "750": 17.7, "775": 13.4, "800": 10.4, "825": 8.05 }
          },
          {
            name: "SA-193 Gr.B8Mclass 2, 30 < t <= 36",
            material: "SA-193 Gr.B8M",
            size_class: "class 2, 30 < t <= 36",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 127, "100": 121, "125": 114, "150": 107, "175": 103, "200": 99.2, "225": 96, "275": 92.9, "300": 90.1, "325": 87.8, "350": 86.5, "375": 86.2, "400": 86.2, "425": 86.2, "450": 86.2, "475": 86.2 }
          },
          {
            name: "SA-193 Gr.B8Mclass 2,24 < t <= 30",
            material: "SA-193 Gr.B8M",
            size_class: "class 2,24 < t <= 30",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 127, "100": 121, "125": 115, "150": 112, "175": 112, "200": 112, "225": 112, "275": 112, "300": 112, "325": 112, "350": 112, "375": 112, "400": 112, "425": 112, "450": 112, "475": 112 }
          },
          {
            name: "SA-193 Gr.B8Mclass 2,20 < t <= 24",
            material: "SA-193 Gr.B8M",
            size_class: "class 2,20 < t <= 24",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 127, "100": 121, "125": 115, "150": 112, "175": 112, "200": 112, "225": 112, "275": 112, "300": 112, "325": 112, "350": 112, "375": 112, "400": 112, "425": 112, "450": 112, "475": 112 }
          },
          {
            name: "SA-193 Gr.B8Mclass 2, t < 20",
            material: "SA-193 Gr.B8M",
            size_class: "class 2, t < 20",
            unit: "Stress (MPa)",
            stresses: { "40": 152, "65": 152, "100": 152, "125": 152, "150": 152, "175": 152, "200": 152, "225": 152, "275": 152, "300": 152, "325": 152, "350": 152, "375": 152, "400": 152, "425": 152, "450": 152, "475": 152 }
          },
          {
            name: "SA-193 Gr.B8class 1",
            material: "SA-193 Gr.B8",
            size_class: "class 1",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 122, "100": 114, "125": 108, "150": 103, "175": 99.1, "200": 95.7, "225": 92.8, "275": 87.2, "300": 84.5, "325": 83.1, "350": 82.5, "375": 81.1, "400": 79.2, "425": 77.3, "450": 76, "475": 74.8, "500": 73.6, "525": 72.4, "550": 70.8, "575": 68.9, "600": 65.4, "625": 51, "650": 41, "675": 32.9, "700": 26.5, "725": 21.3, "750": 17.2, "775": 13.9, "800": 11.1, "825": 8.73 }
          },
          {
            name: "SA-193 Gr.B8class 2, 30 < t <= 36",
            material: "SA-193 Gr.B8",
            size_class: "class 2, 30 < t <= 36",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 122, "100": 114, "125": 108, "150": 103, "175": 99.2, "200": 95.7, "225": 92.6, "275": 89.9, "300": 87.8, "325": 86.5, "350": 86.2, "375": 86.2, "400": 86.2, "425": 86.2, "450": 86.2, "475": 86.2 }
          },
          {
            name: "SA-193 Gr.B8class 2,24 < t <= 30",
            material: "SA-193 Gr.B8",
            size_class: "class 2,24 < t <= 30",
            unit: "Stress (MPa)",
            stresses: { "40": 130, "65": 121, "100": 115, "125": 114, "150": 112, "175": 112, "200": 112, "225": 112, "275": 112, "300": 112, "325": 112, "350": 112, "375": 112, "400": 112, "425": 112, "450": 112, "475": 112 }
          },
          {
            name: "SA-193 Gr.B8class 2,20 < t <= 24",
            material: "SA-193 Gr.B8",
            size_class: "class 2,20 < t <= 24",
            unit: "Stress (MPa)",
            stresses: { "40": 138, "65": 138, "100": 138, "125": 138, "150": 138, "175": 138, "200": 138, "225": 138, "275": 138, "300": 138, "325": 138, "350": 138, "375": 138, "400": 138, "425": 138, "450": 138, "475": 138 }
          },
          {
            name: "SA-193 Gr.B8class 2, t < 20",
            material: "SA-193 Gr.B8",
            size_class: "class 2, t < 20",
            unit: "Stress (MPa)",
            stresses: { "40": 172, "65": 172, "100": 172, "125": 172, "150": 172, "175": 172, "200": 172, "225": 172, "275": 172, "300": 172, "325": 172, "350": 172, "375": 172, "400": 172, "425": 172, "450": 172, "475": 172 }
          }
        ];
    }
}

export default Bolts;